import { UserRoles } from 'app-constants'

export const userRoleOptions = [
  {
    value: UserRoles.NO_ACCEESS,
    label: 'No access'
  },
  {
    value: UserRoles.VIEWER,
    label: 'Viewer'
  },
  {
    value: UserRoles.CONTRIBUTOR,
    label: 'Contributor'
  },
  {
    value: UserRoles.OWNER,
    label: 'Owner'
  }
]
